import { compose } from 'lodash/fp'
import { withTranslation } from 'react-i18next'
import Drawer from './Drawer'
import withState from './withState'

export default compose(
  withState,
  withTranslation(),
)(Drawer)
